import { Tag } from 'iconsax-react'

import { Button } from '@/components/ui/button'
import { SocialMirrorPalette } from '@/utils/palette/SocialMirrorPalette'
import { Chip } from '../Chip/Chip'

interface PlanCardProps {
  title: string
  price: string
  currencySymbol?: string
  discount?: string
  billing: string
  benefit: string
  buttonText: string
  isPrimary?: boolean
  onAction: () => void
}

export const PlanCard = ({
  title,
  price,
  currencySymbol = '$',
  discount,
  billing,
  benefit,
  buttonText,
  isPrimary = false,
  onAction,
}: PlanCardProps) => {
  return (
    <div className="flex flex-col p-4 rounded-2xl border-2 h-full border-neutralColor10">
      <div className="flex flex-col gap-2 flex-1">
        <div className="flex flex-col gap-2 min-h-[70px] justify-start">
          <div className="min-h-[28px]">
            {discount && (
              <div className="flex">
                <Chip
                  text={discount}
                  variant="red"
                  size="tag"
                  icon={
                    <Tag size="18" color={SocialMirrorPalette.dynamicRed} />
                  }
                />
              </div>
            )}
          </div>

          <h3 className="text-neutralColor80 text-lg font-bold leading-tight">
            {title}
          </h3>
        </div>

        <div className="flex flex-col min-h-[60px] justify-center gap-2">
          <div className="flex items-start">
            <span className="text-neutralColor80 text-base font-bold mt-1">
              {currencySymbol}
            </span>
            <span className="text-neutralColor80 text-3xl font-bold tracking-tight">
              {price}
            </span>
          </div>
          <p className="text-neutralColor60 text-xs font-medium">{billing}</p>
        </div>

        <div className="flex flex-col gap-4 min-h-[40px] justify-center">
          <div className="flex items-center gap-3">
            <span className="text-neutralColor80 shrink-0">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5 13L9 17L19 7"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
            <p className="text-neutralColor80 text-sm font-medium">{benefit}</p>
          </div>
        </div>
      </div>

      <div className="mt-4">
        <Button
          onClick={onAction}
          className={`w-full rounded-2xl h-12 text-sm font-bold shadow-none border ${
            isPrimary
              ? 'bg-primaryColor hover:bg-neutralColor hover:text-staticWhite'
              : 'bg-neutralColor5 hover:bg-neutralColor hover:text-staticWhite text-neutralColor80'
          }`}
        >
          {buttonText}
        </Button>
      </div>
    </div>
  )
}
